import {combineReducers} from 'redux';
import OtpReducer from './otpReducer';
import VerifyReducer from '../reducers/verifyReducer'
import UpdateReducer from '../reducers/updateReducer'
import getupdaterequests from '../reducers/getUpdateRequestReducer';
import authReducer from '../reducers/authReducer';
import faceAuthReducer from './verifyFaceReducer';
import setUinReducer from '../reducers/setUinReducer';
import sessionReducer from './insessionReducer';
import verifyRegistrationReducer from "./verifyRegistration";
import packetStatusReducer from "./packetStatusReducer";
import smsResendReducer from "./smsResendReducer";
import locationReducer from './locationReducer';
import cardProcessorDataReducer from './cardProcessorDataReducer';
import contactOtpReducer from './contactOtpReducer';

const rootReducer = combineReducers({

  otp: OtpReducer,
  contactOtp: contactOtpReducer,
  verify: VerifyReducer,
  update: UpdateReducer,
  residentlog: getupdaterequests,
  auth: authReducer,
  faceAuth: faceAuthReducer,
  uin: setUinReducer,
  session: sessionReducer,
  packetStatus:packetStatusReducer,
  smsResend:smsResendReducer,
  location:locationReducer,
  pdfData:cardProcessorDataReducer
});

export default rootReducer;
